function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip-Zeichenfl\\xE4che_6"
}, /*#__PURE__*/React.createElement("rect", {
  width: 91,
  height: 59
})));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Zeichenfl\\xE4che_6",
  "data-name": "Zeichenfl\\xE4che \\u2013 6",
  clipPath: "url(#clip-Zeichenfl\\xE4che_6)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Gruppe_7",
  "data-name": "Gruppe 7",
  transform: "translate(-40 -347)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Rechteck_3",
  "data-name": "Rechteck 3",
  transform: "translate(43 379)",
  fill: "#e6e2e6",
  stroke: "#c6c6c6",
  strokeWidth: 1
}, /*#__PURE__*/React.createElement("rect", {
  width: 24,
  height: 24,
  rx: 2,
  stroke: "none"
}), /*#__PURE__*/React.createElement("rect", {
  x: 0.5,
  y: 0.5,
  width: 23,
  height: 23,
  rx: 1.5,
  fill: "none"
})), /*#__PURE__*/React.createElement("g", {
  id: "Rechteck_4",
  "data-name": "Rechteck 4",
  transform: "translate(73 379)",
  fill: "#fff",
  stroke: "#c6c6c6",
  strokeWidth: 1
}, /*#__PURE__*/React.createElement("rect", {
  width: 24,
  height: 24,
  rx: 2,
  stroke: "none"
}), /*#__PURE__*/React.createElement("rect", {
  x: 0.5,
  y: 0.5,
  width: 23,
  height: 23,
  rx: 1.5,
  fill: "none"
})), /*#__PURE__*/React.createElement("g", {
  id: "Rechteck_5",
  "data-name": "Rechteck 5",
  transform: "translate(103 379)",
  fill: "#e6e2e6",
  stroke: "#c6c6c6",
  strokeWidth: 1
}, /*#__PURE__*/React.createElement("rect", {
  width: 24,
  height: 24,
  rx: 2,
  stroke: "none"
}), /*#__PURE__*/React.createElement("rect", {
  x: 0.5,
  y: 0.5,
  width: 23,
  height: 23,
  rx: 1.5,
  fill: "none"
})), /*#__PURE__*/React.createElement("g", {
  id: "Rechteck_6",
  "data-name": "Rechteck 6",
  transform: "translate(73 349)",
  fill: "#fff",
  stroke: "#c6c6c6",
  strokeWidth: 1
}, /*#__PURE__*/React.createElement("rect", {
  width: 24,
  height: 24,
  rx: 2,
  stroke: "none"
}), /*#__PURE__*/React.createElement("rect", {
  x: 0.5,
  y: 0.5,
  width: 23,
  height: 23,
  rx: 1.5,
  fill: "none"
})), /*#__PURE__*/React.createElement("path", {
  id: "ic_arrow_drop_down_24px",
  d: "M7,10l5,5,5-5Z",
  transform: "translate(73 379)",
  fill: "#7d7d7d"
}), /*#__PURE__*/React.createElement("path", {
  id: "ic_arrow_drop_down_24px-2",
  "data-name": "ic_arrow_drop_down_24px",
  d: "M10,0,5,5,0,0Z",
  transform: "translate(112.5 396.5) rotate(-90)"
}), /*#__PURE__*/React.createElement("path", {
  id: "ic_arrow_drop_down_24px-3",
  "data-name": "ic_arrow_drop_down_24px",
  d: "M7,10l5,5,5-5Z",
  transform: "translate(67.5 379.5) rotate(90)"
}), /*#__PURE__*/React.createElement("path", {
  id: "ic_arrow_drop_down_24px-4",
  "data-name": "ic_arrow_drop_down_24px",
  d: "M7,15l5-5,5,5Z",
  transform: "translate(73 349)",
  fill: "#7d7d7d"
})));

var SvgArrowKeys = function SvgArrowKeys(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 91,
    height: 59,
    viewBox: "0 0 91 55",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgArrowKeys, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/arrow-keys.a0038c1f.svg";
export { ForwardRef as ReactComponent };